import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import cx from "classnames";

const Cubes = ({ storage, onChange }) => {
  const [selected, setSelected] = useState(false);
  return (
    <>
      <Row className="mb-3 row ">
        <p className="fw-semibold mb-2">אנא סמן כמה קוב נדרש לאחסנה:</p>
        <ButtonGroup className="mb-3 cubeButtons ">
          {storage?.length
            ? storage.map((cube, i) => (
                <ToggleButton
                  // sx={{ '&:hover': { backgroundColor: 'yellow !important' } }}
                  key={i}
                  id={`cube-${i}`}
                  variant={i % 2 ? "outline-secondary" : "outline-secondary"}
                  name="cube"
                  value={cube.entityId}
                  className={cx("cube", {
                    active: cube.entityId === selected.entityId,
                  })}
                  onClick={() => {
                    onChange({ volume: Number(cube.title.match(/\d+/)[0]) });
                    setSelected(cube);
                  }}
                >
                  <h5>{cube.title}</h5>
                  {/* <p>{cube.description}</p> */}
                  {/* <img src={cube.image}/> */}
                </ToggleButton>
              ))
            : "No storage"}
        </ButtonGroup>
      </Row>
    </>
  );
};

export default Cubes;
